import React, { useState, useEffect, useMemo, useCallback } from "react";
import ArrowBackIosNewRoundedIcon from "@mui/icons-material/ArrowBackIosNewRounded";
import { Button, Typography, OutlinedInput, FormControl, Card,
  CardContent,
  CardHeader,
  Checkbox,
  Avatar,
  Stack,
  Grid,
  Box,
  CardMedia, AvatarGroup } from "@mui/material";
import cardbackground from "../../assets/landing_page/new/Frame 2095584531.svg";
import ThreeDot from "react-loading-indicators/ThreeDot";
import tick from "../../assets/landing_page/new/teenyicons_tick-circle-solid.svg";
import GenericDialog from "../../components/GenericDialogBox/index";
import http from "../../utils/http-common";
import { toast } from "react-toastify";
import { useSelector, useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import {
  setUserForDelete,
  setUserForEdit,
  setUserForView,
} from "../../Slices/userslice";
import { projects } from "../../utils/data/Private-Pages/data";
function AddUser({ props }) {
  const user_name = localStorage.getItem("user_name");
    const userId = localStorage.getItem("user_id");
  const userEmail = localStorage.getItem("email");
  const ProjectCard = React.memo(
    function ProjectCard({
      title,
      createdBy,
      email_address,
      avatars,
      extraCount,
      onSelect,
      isSelected,
    }) {
      return (
        <Card variant='outlined' sx={{ maxWidth: 200, borderRadius: 2 }}>
          <CardHeader
            title={
              <Stack
                direction='row'
                alignItems='center'
                justifyContent='space-between'>
                <Typography
                  variant='h6'
                  sx={{
                    fontFamily: "Inter, sans-serif",
                    fontSize: "12px",
                    fontWeight: 600,
                    lineHeight: "14.52px",
                    textAlign: "left",
                    marginRight: "20px",
                  }}>
                  {title}
                </Typography>

                <Checkbox
                  checked={isSelected}
                  onChange={(e) => onSelect(title, e.target.checked)}
                  sx={{
                    "&.Mui-checked": {
                      color: "var(--Primary-Color, #FF2800)", // Color when checked
                    },
                  }}
                />
              </Stack>
            }
            sx={{ pb: 0, pt: 0, backgroundColor: "#E5EEFB66" }}
          />
          <CardContent sx={{ px: 1, py: 0 }}>
            <CardMedia
              component='img'
              image={cardbackground}
              alt='Project Timeline'
              sx={{
                height: 60,
                borderRadius: 1,
                objectFit: "cover",
                backgroundColor: "#E5EEFB66",
              }}
            />

            <Box
              sx={{
                borderBottom: "1px solid #ccc",
                backgroundColor: "#E5EEFB66",
              }}
            />

            <Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                backgroundColor: "transparent",
              }}>
              <Box>
                <Typography
                  variant='body1'
                  color='textSecondary'
                  sx={{
                    fontFamily: "Inter, sans-serif",
                    fontSize: "10px",
                    fontWeight: 500,
                    lineHeight: "16px",
                    textAlign: "left",
                    marginTop: "5px",
                  }}>
                  Created by
                </Typography>
                <Typography
                  variant='body2'
                  sx={{
                    fontFamily: "Inter, sans-serif",
                    fontSize: "10px",
                    fontWeight: 500,
                    lineHeight: "16px",
                    textAlign: "left",
                  }}>
                  {email_address}
                </Typography>
              </Box>

              <Stack
                direction='row'
                alignItems='center'
                spacing={1}
                sx={{
                  position: "relative",
                  top: "4px",
                  right: "0px",
                  opacity: 1,
                }}>
              </Stack>
            </Box>
          </CardContent>
        </Card>
      );
    },
    (prevProps, nextProps) => {
      // Custom comparison to prevent re-render unless specific props change
      return (
        prevProps.title === nextProps.title &&
        prevProps.isSelected === nextProps.isSelected &&
        prevProps.avatars === nextProps.avatars &&
        prevProps.createdBy === nextProps.createdBy
      );
    },
    ([title, createdBy, avatars, extraCount, onSelect, isSelected]) => [
      title,
      createdBy,
      avatars,
      extraCount,
      onSelect,
      isSelected,
    ]
  );

  const memoizedProjects = useMemo(() => {
    return projects.map((project) => ({
      ...project,
      avatars: [...project.avatars], // Memoize avatars
    }));
  }, []);
  const [open, setOpen] = useState(false);
  const [checkData, setCheckData] = useState([]);
  const [loading, setLoading] = useState(false);  
  const validatePhoneNumber = (number) => {
    const phoneRegex = /^[+]?[0-9]{10,15}$/; // Adjust regex based on your phone number format
    return phoneRegex.test(number);
  };

  // Email Validation
  const validateEmail = (email) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/; // Basic email validation regex
    return emailRegex.test(email);
  };
  const handleOpen = () => {
    if (!userName.trim()) {
      toast.error("Please enter a User Name");
      return;
    }
  
    if (userName.length > 25) {
      toast.error("User Name should not exceed 25 characters");
      return;
    }
  
    if (!email.trim()) {
      toast.error("Please enter an Email ID");
      return;
    }
  
    if (phoneNumber && !validatePhoneNumber(phoneNumber)) {
      toast.error("Invalid phone number.");
      return;
    }
  
    if (!validateEmail(email)) {
      toast.error("Invalid email address.");
      return;
    }
  
    if (skillSet && skillSet.length > 100) {
      toast.error("Skill set should not exceed 100 characters");
      return;
    }
  
    // ✅ Check if username and email match localStorage
    if (email.trim().toLowerCase() === userEmail?.trim().toLowerCase()
    ) {
      toast.error("The user details already available, please provide a different user.");
      return;
    }
  
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { user_id, isEdit, isView, isDelete, table } = useSelector(
    (state) => state.userslice
  );

  const [userIdData, setuserIdData] = useState(localStorage.getItem("userId") || "");
  const [userName, setUserName] = useState("");
  const [email, setEmail] = useState("");
  const [phoneNumber, setPhoneNumber] = useState("");
  const [skillSet, setSkillSet] = useState("");
  const [imageChanged, setImageChanged] = useState(false);
  const handleInputChange = (e, setter) => {
    setter(e.target.value);
  };
  const handleInputChange1 = (e, setter) => {
    const value = e.target.value;
    // Allow only numeric input
    const numericValue = value.replace(/[^0-9]/g, "");
    setter(numericValue);
  };
  const [selectedProjects, setSelectedProjects] = useState([]);
  const [selectedProjects1, setSelectedProjects1] = useState([]);
  
  const handleSelectProject = (title, isChecked) => {
    setCheckData((prevChecked) => {
      if (isChecked && !prevChecked.includes(title)) {
        return [...prevChecked, title];
      }
      if (!isChecked && prevChecked.includes(title)) {
        return prevChecked.filter(item => item !== title);
      }
      return prevChecked;
    });

    // Find the corresponding plan based on the title
    const matchedPlan = planData.find((plan) => plan.plan_name === title);

    if (!isView && matchedPlan) {
      const planId = matchedPlan.plan_id;
      setSelectedProjects((prevSelected) =>
        prevSelected.includes(title)
          ? prevSelected.filter((project) => project !== title)
          : [...prevSelected, title]
      );
      setSelectedProjects1((prevSelected) => {
        // Remove any existing entry for this planId
        const updatedSelected = prevSelected.filter(
          (item) => item.true !== planId && item.false !== planId
        );
  
        // Add new entry based on isChecked
        return isChecked
          ? [...updatedSelected, { true: planId }]
          : [...updatedSelected, { false: planId }];
      });
    }



  };


  function base64ToBlob(base64, mime) { 
    try {
      const byteCharacters = atob(base64);
      const byteArrays = [];
  
      for (let offset = 0; offset < byteCharacters.length; offset += 512) {
        const slice = byteCharacters.slice(offset, offset + 512);
        const byteNumbers = new Array(slice.length);
        for (let i = 0; i < slice.length; i++) {
          byteNumbers[i] = slice.charCodeAt(i);
        }
        const byteArray = new Uint8Array(byteNumbers);
        byteArrays.push(byteArray);
      }
  
      return new Blob(byteArrays, { type: mime });
    } catch (error) {
      console.error("Error decoding Base64:", error);
      return null;
    }
  }
  
  function extractBase64Data(base64String) {
    const parts = base64String.split(",");
    if (parts.length === 2) {
      return parts[1];
    } else {
      console.error("Invalid Base64 format");
      return null;
    }
  }
  
  const handleCreateUser = async () => {
    setLoading(true);
    const formData = new FormData();
    const plansToAdd1 = selectedProjects1
    .filter((project) => project.true) // Keep only items with a "true" key
    .map((project) => project.true); // Map to get the plan_id values

  const plansToDelete1 = selectedProjects1
    .filter((project) => project.false) // Keep only items with a "false" key
    .map((project) => project.false); // Map to get the plan_id values
      if (isEdit) {
        if (plansToAdd1.length > 0) {
          formData.append("plans_to_add", plansToAdd1);
        }
        if (plansToDelete1.length > 0) {
          formData.append("plans_to_delete", plansToDelete1);
        }
      }
  if (!isEdit) {
    formData.append("plan_id", plansToAdd1);
  }
  formData.append("user_name", userName);
  formData.append("email", email);
  formData.append("phone_number", phoneNumber);
  formData.append("skill_set", skillSet);
  
  
    if (image && !isDelete) {
      if (isEdit) {
        if (imageChanged) {
          const base64Image = extractBase64Data(image);
          if (base64Image) { // Ensure the data is valid
            const mime = "image/jpeg";
            const blob = base64ToBlob(base64Image, mime);
            if (blob) { // Ensure blob creation was successful
              const file = new File([blob], "filename.jpeg", { type: mime });
              formData.append("uploaded_picture_path", file);
            }
          }
        } else {
          formData.append("uploaded_picture_path", image);
        }
      } else {
        const base64Image = extractBase64Data(image);
        if (base64Image) {
          const mime = "image/jpeg";
          const blob = base64ToBlob(base64Image, mime);
          if (blob) {
            const file = new File([blob], "filename.jpeg", { type: mime });
            formData.append("uploaded_picture_path", file);
          }
        }
      }
    }
  
    formData.forEach((value, key) => {
    });
    try {
      if (isEdit) {
        const response = await http.put(
          `/auth_service/user/update/${user_id}`,
          formData,
          {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          }
        );

        if (response.data.success === true) {
          toast.success(
            <>
              <div
                style={{
                  fontFamily: "Inter, sans-serif",
                  fontSize: "14px",
                  fontWeight: "600",
                  lineHeight: "24px",
                  textAlign: "left",
                  marginBottom: "8px",
                  marginTop: "10px",
                }}>
                User Updated Successfully
              </div>
            </>,
            {
              icon: (
                <img
                  src={tick}
                  alt='Success Icon'
                  style={{ width: "20px", height: "20px", color: "#0057D5" }}
                />
              ),
            }
          );
          handleClose();
          handleNavigate("/home/users", { state: { setGridView: table } })();
        }
      } else if (isDelete) {
        const response = await http.delete(
          `/auth_service/user_master/${user_id}`
        );

        if (response.data.success === true) {
          toast.success(
            <>
              <div
                style={{
                  fontFamily: "Inter, sans-serif",
                  fontSize: "14px",
                  fontWeight: "600",
                  lineHeight: "24px",
                  textAlign: "left",
                  marginBottom: "8px",
                  marginTop: "10px",
                }}>
                User Deleted Successfully
              </div>
            </>,
            {
              icon: (
                <img
                  src={tick}
                  alt='Success Icon'
                  style={{ width: "20px", height: "20px", color: "#0057D5" }}
                />
              ),
            }
          );
          handleNavigate("/home/users", { state: { setGridView: table } })();
          handleClose();
        }
      } else {
        const response = await http.post(
          "/auth_service/user/create",
          formData,
          {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          }
        );

        if (response.data.success === true) {
          toast.success(
            <>
              <div
                style={{
                  fontFamily: "Inter, sans-serif",
                  fontSize: "14px",
                  fontWeight: "600",
                  lineHeight: "24px",
                  textAlign: "left",
                  marginBottom: "8px",
                }}>
                User Created Successfully
              </div>
              <div
                style={{
                  fontFamily: "Inter, sans-serif",
                  fontSize: "14px",
                  fontWeight: "500",
                  lineHeight: "22px",
                  textAlign: "left",
                }}>
                The new user has been added to your team and is ready to
                collaborate.
              </div>
            </>,
            {
              icon: (
                <img
                  src={tick}
                  alt='Success Icon'
                  style={{ width: "20px", height: "20px", color: "#0057D5" }}
                />
              ),
            }
          );
          handleNavigate("/home/users", { state: { setGridView: table } })();
          handleClose();
          // onClose();
        } else if (response.data.success === false) {
          toast.error(response.data.message);
        }
      }
    } catch (error) {
      toast.error("An error occured");
      console.error("Error creating user:", error);
    } finally {
      setLoading(false); // Stop loading regardless of success or failure
    }
  };
  const [image, setImage] = useState(null);

  const handleFileChange = (event) => {
    if (isEdit) {
      setImageChanged(true);
    }
    const file = event.target.files[0];
    if (file) {
      const validTypes = ["image/jpeg", "image/jpg"];
      if (!validTypes.includes(file.type)) {
        alert("Please select a JPG or JPEG image.");
        return; // Exit the function if the file type is not valid
      }
      const reader = new FileReader();
      reader.onloadend = () => {
        setImage(reader.result);
      };
      reader.readAsDataURL(file);
    }
  };

  const handleUploadClick = () => {
    document.getElementById("file-input").click();
  };

  const handleRemovePicture = () => {
    setImage(null);
  };
  const handleNavigate = (path) => () => {
    navigate(path);
    if (isEdit) {
      dispatch(setUserForEdit({ user_id: null, isEdit: false }));
    }
    if (isView) {
      dispatch(setUserForView({ user_id: null, isView: false }));
    }
    if (isDelete) {
      dispatch(setUserForDelete({ user_id: null, isDelete: false }));
    }
  };

  useEffect(() => {
    return () => {
      dispatch(setUserForEdit({ user_id: null, isEdit: false }));
      dispatch(setUserForView({ user_id: null, isView: false }));
      dispatch(setUserForDelete({ user_id: null, isDelete: false }));
    };
  }, []);

  useEffect(() => {
    if (user_id && user_id !== userIdData) {
      setuserIdData(user_id);

      localStorage.setItem("userId", user_id);
    }
  }, [userIdData]);

  // Fetch plan data when `planIdData` changes
  useEffect(() => {
    if ((isEdit && userIdData) || (isView && userIdData) || (isDelete && userIdData)) {
      fetchUserData(userIdData);
    }
  }, [userIdData, isEdit, isView, isDelete]);
  useEffect(() => {
    if ((isEdit && user_id) || (isView && user_id) || (isDelete && user_id)) {
      fetchUserData();
    }
  }, [user_id, isEdit, isView, isDelete]);
  const [userData, setUserData] = useState([]);
  const fetchUserData = async () => {
    try {
      const response = await http.get(`/auth_service/user/view/${user_id||userIdData}`);
      if (response.status === 200) {
        const data = response.data;
        setUserData(data);
        setImage(data.uploaded_picture_path || "");
        setUserName(data.user_name || "");
        setEmail(data.email || "");
        setPhoneNumber(data.phone_number || "");
        setSkillSet(data.skill_set || "");
        if (typeof data.plan_id === "string" && data.plan_id) { 
          const projectsArray = data.plan_id
            .split(",")
            .map((project) => project.trim());
          setSelectedProjects1(projectsArray);
        } else {
          setSelectedProjects1([]); // Optionally clear the array if plan_id is not a string or is empty
        }
        if (data.plan_name && Array.isArray(data.plan_name)) {
          setSelectedProjects(data.plan_name);
        }
      }
    } catch (error) {
      console.error("Error fetching user data", error);
    }
  };
  useEffect(() => {
    getPlan();
  }, []);


  const [planData, setPlanData] = useState([]);
  const getPlan = async () => {
    try {
      const response = await http.get(
        "/master_service/get_all/plan_master/records"
      );

      if (response.status === 200) {

        const filteredData = response.data.filter(
          (plan) => plan.user_id === userId && plan.access_name !== "no_access"
        );
        setPlanData(filteredData);
        const planIdsInPlan = filteredData.map(plan => plan.plan_id);
      }
    } catch (error) {
      console.error("Error fetching data", error);
    }
  };
  return (
    <div>
      <div
        style={{
          fontFamily: "Inter, sans-serif",
          fontSize: "12px",
          fontWeight: 500,
          lineHeight: "14.52px",
          textAlign: "left",
        }}>
        <span
    style={{ cursor: "pointer" }}
    onClick={handleNavigate("/home/users")}
  >
    Stakeholders
  </span> &gt;{" "}
        {isEdit
          ? "Edit"
          : isView
            ? "View"
            : isDelete
              ? "Delete"
              : "Add"}
      </div>
      <div
        style={{
          display: "flex",
          alignItems: "center",
          marginTop: "15px",
        }}>
        <ArrowBackIosNewRoundedIcon
          fontSize='small'
          onClick={handleNavigate("/home/users")}
        />
        <div
          style={{
            fontFamily: "Inter, sans-serif",
            fontSize: "20px",
            fontWeight: 600,
            lineHeight: "21px",
            marginLeft: "8px",
          }}>
          {isEdit
            ? "Edit"
            : isView
              ? "View"
              : isDelete
                ? "Delete"
                : "Add"}
        </div>
      </div>
      <div style={{ display: "flex", alignItems: "center" }}>
        <div
          style={{
            width: "90px",
            height: "90px",
            borderRadius: "50%",
            border: "1px solid #ccc",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            overflow: "hidden",
            marginTop: "20px",
            backgroundColor: !image ? "#FF2800" : "white",
          }}>
          {image ? (
            <img
              src={image}
              alt='Selected'
              style={{
                width: "100%",
                height: "100%",
                objectFit: "cover",
              }}
            />
          ) : (
            <Typography
              sx={{
                color: "white",
                fontSize: "36px",
                fontWeight: "500",
                textTransform: "uppercase",
                fontFamily: "Inter, sans-serif",
              }}>
              {userName?.charAt(0) || ""}
            </Typography>
          )}
        </div>
        {!isView && !isEdit && !isDelete && (
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              marginLeft: "58px",
            }}>
            <Button
              variant='contained'
              sx={{
                fontFamily: "Inter, sans-serif",
                textTransform: "none",
                fontWeight: 500,
                backgroundColor: "#FF2800",
                padding: "6px 16px",
                "&:hover": {
                  backgroundColor: "#FF2800",
                },
                marginTop: "10px",
              }}
              onClick={handleUploadClick}>
              Upload Picture
            </Button>
            <input
              type='file'
              id='file-input'
              style={{ display: "none" }}
              accept='image/*'
              onChange={handleFileChange}
            />
            <Button
              variant='contained'
              sx={{
                fontFamily: "Inter, sans-serif",
                textTransform: "none",
                fontWeight: 500,
                backgroundColor: "#FAFAFA",
                "&:hover": {
                  backgroundColor: "#FAFAFA",
                },
                padding: "6px 16px",
                color: "black",
                border: "1px solid black",
                marginTop: "12px",
              }}
              onClick={handleRemovePicture}>
              Remove Picture
            </Button>
          </div>
        )}
      </div>
      <div
        style={{
          display: "flex",
          alignItems: "center",
          marginTop: "10px",
          marginLeft: "2px",
        }}>
        <Typography
          variant='body2'
          sx={{
            fontFamily: "Inter, sans-serif",
            fontSize: "14px",
            fontWeight: 500,
            lineHeight: "20px",
            textAlign: "left",
          }}>
          User Name{" "}
          <span
            style={{
              color: "#FF2800",
              //backgroundColor: "#FF2800",
              padding: "0 2px",
              borderRadius: "50%",
            }}>
            *
          </span>
        </Typography>
        <div style={{ marginLeft: "60px", flexGrow: 1 }}>
          <FormControl sx={{ height: "32px", width: "100%" }}>
            <OutlinedInput
              placeholder='Enter User Name'
              value={userName}
              disabled={isView || isEdit || isDelete}
              onChange={(e) => handleInputChange(e, setUserName)}
              sx={{
                height: "100%",
                backgroundColor: "white",
                "& .MuiOutlinedInput-input": {
                  // Styles for the input field
                },
                "& .MuiInputBase-input::placeholder": {
                  fontFamily: "Inter, sans-serif",
                  fontSize: "12px",
                  fontWeight: 500,
                  lineHeight: "20px",
                  textAlign: "left",
                },
                "& .MuiOutlinedInput-root": {
                  "& fieldset": {
                    borderColor: "gray", // Default border color
                  },
                  "&:hover fieldset": {
                    borderColor: "gray", // Border color on hover
                  },
                  "&.Mui-focused fieldset": {
                    borderColor: "gray", // Border color on focus
                  },
                },
              }}
            />
          </FormControl>
        </div>
      </div>
      <div
        style={{
          display: "flex",
          alignItems: "center",
          marginTop: "10px",
          marginLeft: "2px",
        }}>
        <Typography
          variant='body2'
          sx={{
            fontFamily: "Inter, sans-serif",
            fontSize: "14px",
            fontWeight: 500,
            lineHeight: "20px",
            textAlign: "left",
          }}>
          Email ID{" "}
          <span
            style={{
              color: "#FF2800",
              //backgroundColor: "#FF2800",
              padding: "0 2px",
              borderRadius: "50%",
            }}>
            *
          </span>
        </Typography>
        <div style={{ marginLeft: "80px", flexGrow: 1 }}>
          <FormControl sx={{ height: "32px", width: "100%" }}>
            <OutlinedInput
              placeholder='Enter Email ID'
              value={email}
              disabled={isView || isEdit || isDelete}
              onChange={(e) => handleInputChange(e, setEmail)}
              sx={{
                height: "100%",
                backgroundColor: "white",
                "& .MuiOutlinedInput-input": {
                  // Styles for the input field
                },
                "& .MuiInputBase-input::placeholder": {
                  fontFamily: "Inter, sans-serif",
                  fontSize: "12px",
                  fontWeight: 500,
                  lineHeight: "20px",
                  textAlign: "left",
                },
                "& .MuiOutlinedInput-root": {
                  "& fieldset": {
                    borderColor: "gray", // Default border color
                  },
                  "&:hover fieldset": {
                    borderColor: "gray", // Border color on hover
                  },
                  "&.Mui-focused fieldset": {
                    borderColor: "gray", // Border color on focus
                  },
                },
              }}
            />
          </FormControl>
        </div>
      </div>
      <div
        style={{
          display: "flex",
          alignItems: "center",
          marginTop: "10px",
          marginLeft: "2px",
        }}>
        <Typography
          variant='body2'
          sx={{
            fontFamily: "Inter, sans-serif",
            fontSize: "14px",
            fontWeight: 500,
            lineHeight: "20px",
            textAlign: "left",
          }}>
          Phone Number{" "}
        </Typography>
        <div style={{ marginLeft: "49px", flexGrow: 1 }}>
          <FormControl sx={{ height: "32px", width: "100%" }}>
            <OutlinedInput
              placeholder='Enter Phone Number'
              value={phoneNumber}
              disabled={isView}
              onChange={(e) => handleInputChange1(e, setPhoneNumber)}
              sx={{
                height: "100%",
                backgroundColor: "white",
                "& .MuiOutlinedInput-input": {
                  // Styles for the input field
                },
                "& .MuiInputBase-input::placeholder": {
                  fontFamily: "Inter, sans-serif",
                  fontSize: "12px",
                  fontWeight: 500,
                  lineHeight: "20px",
                  textAlign: "left",
                },
                "& .MuiOutlinedInput-root": {
                  "& fieldset": {
                    borderColor: "gray", // Default border color
                  },
                  "&:hover fieldset": {
                    borderColor: "gray", // Border color on hover
                  },
                  "&.Mui-focused fieldset": {
                    borderColor: "gray", // Border color on focus
                  },
                },
              }}
            />
          </FormControl>
        </div>
      </div>
      <div
        style={{
          display: "flex",
          alignItems: "center",
          marginTop: "10px",
          marginLeft: "2px",
        }}>
        <Typography
          variant='body2'
          sx={{
            fontFamily: "Inter, sans-serif",
            fontSize: "14px",
            fontWeight: 500,
            lineHeight: "20px",
            textAlign: "left",
          }}>
          Skill Set{" "}
        </Typography>
        <div style={{ marginLeft: "95px", flexGrow: 1 }}>
          <FormControl sx={{ height: "32px", width: "100%" }}>
            <OutlinedInput
              placeholder='Enter Skill Set of the user'
              value={skillSet}
              disabled={isView}
              onChange={(e) => handleInputChange(e, setSkillSet)}
              sx={{
                height: "100%",
                backgroundColor: "white",
                "& .MuiOutlinedInput-input": {
                  // Styles for the input field
                },
                "& .MuiInputBase-input::placeholder": {
                  fontFamily: "Inter, sans-serif",
                  fontSize: "12px",
                  fontWeight: 500,
                  lineHeight: "20px",
                  textAlign: "left",
                },
                "& .MuiOutlinedInput-root": {
                  "& fieldset": {
                    borderColor: "gray", // Default border color
                  },
                  "&:hover fieldset": {
                    borderColor: "gray", // Border color on hover
                  },
                  "&.Mui-focused fieldset": {
                    borderColor: "gray", // Border color on focus
                  },
                },
              }}
            />
          </FormControl>
        </div>
      </div>
      <Typography
        sx={{
          fontFamily: "Inter, sans-serif",
          fontSize: "16px",
          fontWeight: 600,
          lineHeight: "20px",
          textAlign: "left",
          marginTop: "20px",
        }}>
        {isView ? "Plans Associated" : "Grant permission to plan"}
      </Typography>
      <Grid container spacing={2} sx={{ marginTop: "0px" }}>
        {planData
          .filter(
            (project) =>
              project.access_name !== "no_access" && // Exclude plans with no access
              (!isView || selectedProjects.includes(project.plan_name)) // Keep the existing filtering logic
          )
          .map((project, index) => (
            <Grid item key={index}>
              <ProjectCard
                title={project?.plan_name}
                createdBy={project?.created_by}
                email_address={project?.users.email}
                avatars={project?.avatars}
                extraCount={project?.extraCount}
                onSelect={handleSelectProject}
                isSelected={selectedProjects.includes(project?.plan_name)}
              />
            </Grid>
          ))}
      </Grid>
      {!isView && (
        <Box display='flex' justifyContent='flex-end' p={1}>
          <Button
            variant='contained'
            sx={{
              fontFamily: "Inter, sans-serif",
              textTransform: "none",
              fontWeight: 500,
              backgroundColor: "#FAFAFA",
              "&:hover": {
                backgroundColor: "#FAFAFA",
              },
              padding: "4px 12px",
              color: "black",
              border: "1px solid black",

              marginRight: "10px",
            }}
            onClick={handleNavigate("/home/users")}>
            Back
          </Button>
          <Button
            variant='contained'
            sx={{
              fontFamily: "Inter, sans-serif",
              textTransform: "none",
              fontWeight: 500,
              backgroundColor: "#FF2800",
              padding: "4px 12px",
              "&:hover": {
                backgroundColor: "#FF2800",
              },
            }}
            onClick={handleOpen}>
            {isEdit ? "Update" : isDelete ? "Delete" : "Create"}
          </Button>
        </Box>
      )}
      <GenericDialog
        open={open}
        onClose={handleClose}
        title='Create New User'
        content={
          <>
            <div
              style={{
                fontFamily: "Inter, sans-serif",
                fontSize: "20px",
                fontWeight: 700,
                lineHeight: "23.5px",
                textAlign: "left",
              }}>
              {isEdit ? "Update" : isDelete ? "Delete" : "Add"}
            </div>
            <div
              style={{
                fontFamily: "Inter, sans-serif",
                fontSize: "12px",
                fontWeight: 500,
                lineHeight: "14.52px",
                textAlign: "left",
                marginTop: "12px",
              }}>
              {isDelete
                ? "Are you sure you want to delete the user?"
                : isEdit
                  ? "Do you want to update the user details?"
                  : "Are you sure you want to add this user?"}
            </div>
            <Box display='flex' p={1}>
              <Button
                variant='contained'
                fullWidth
                onClick={handleClose}
                sx={{
                  fontFamily: "Inter, sans-serif",
                  textTransform: "none",
                  fontWeight: 500,
                  backgroundColor: "#FAFAFA",
                  "&:hover": {
                    backgroundColor: "#FAFAFA",
                  },
                  padding: "6px 16px",
                  color: "black",
                  border: "1px solid black",

                  marginRight: "10px",
                }}>
                Cancel
              </Button>
              <Button
                variant='contained'
                fullWidth
                sx={{
                  fontFamily: "Inter, sans-serif",
                  textTransform: "none",
                  fontWeight: 500,
                  backgroundColor: "#FF2800",
                  padding: "6px 16px",
                  "&:hover": {
                    backgroundColor: "#FF2800",
                  },
                }}
                onClick={handleCreateUser} disabled={loading}>
                {loading ? ( 
                  <ThreeDot variant='pulsate' color='#FF2800' size='small' />
                ) : (
                  "Proceed"
                )}
              </Button>
            </Box>
          </>
        }
        maxWidth='xs'
        button={<Button onClick={handleClose}>Close</Button>}
        noBackGround={false}
        fullScreen={false}
      />
    </div>
  );
}

export default AddUser;
